export default __webpack_public_path__ + "static/media/sliderbrigadeiro.7635abc3.jpg";